import {Component, OnDestroy, OnInit} from "@angular/core";
import {Response} from "@angular/http";
import * as _ from "underscore";
import {HttpService} from "../../services/http.service";
import {CollectionService} from "../../services/collection.service";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {ILoadChunkResult} from "../../definitions";
import {DocumentService} from "../../services/document.service";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {BusService} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
import {IDocument} from "../../interfaces/document.definition";
import {JP} from "../../helpers/jp";

interface ISavedProfile {
  _id: string;
  _comment: string;
}
declare type ISavedProfiles = ISavedProfile[];
declare const __mongos: string[]; //todo: move to single file (backend-consts.ts)


@Component({
  selector: 'app-profile-utils-page',
  templateUrl: './profile-utils-page.component.html',
  styles: []
})
export class ProfileUtilsPageComponent implements OnInit, OnDestroy {
  MONGO_CONFIGS = _.map(__mongos, (v: string) => ({id: v, label: v}));

  savedProfiles: ISavedProfiles = [];
  profiles = {
    params: {},
    result: ""
  };

  kaya = {
    params: "",
    result: ""
  };

  blank = {
    params: "",
    result: ""
  };

  blankDocument:IDocument;

  VALUE_TYPE = VALUE_TYPE;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private httpService: HttpService,
              private collectionService:CollectionService,
              private documentService:DocumentService,
              private busService:BusService) {
  }


  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe((e) => {
        if (e.document != null){
          this.blankDocument = e.document;
        }
      });

    const params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setNavParams(0, 1)
      .setObjectType(DOCUMENT_TYPES.BLANK_PROFILE);
    this.collectionService.loadChunkCached(params)
      .subscribe((result:ILoadChunkResult) => {
        if (result.documents.length > 0)
        {
          this.documentService.load(E_ENDPOINTS.API, DOCUMENT_TYPES.BLANK_PROFILE, result.documents[0]._id);
        }
        else
        {
          var createParams = paramsHelper.loader()
            .setEndpointId(E_ENDPOINTS.API)
            .setObjectType(DOCUMENT_TYPES.BLANK_PROFILE);
          this.collectionService.createOne(createParams)
            .subscribe(result => this.documentService.load(E_ENDPOINTS.API, DOCUMENT_TYPES.BLANK_PROFILE, result.insertedId))
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  onCopyProfilesClick() {
    this.reset();
    if (!this.profiles.params["_id_dst"]) {
      delete this.profiles.params["_id_dst"];
    }

    this.httpService.post("/profile/copy", this.profiles.params)
      .subscribe((r: Response): void => {
        this.profiles.result = r.json();
      });
  }


  onLoadSavedProfilesClick() {
    this.reset();
    this.httpService.post("/profile/get-saved", this.profiles.params)
      .subscribe((r: Response): void => {
        this.savedProfiles = r.json();
      });
  }


  onUpdateKayasProfileClick() {
    this.reset();
    if (this.assertValidJsonGiven(this.kaya.params)) {
      this.kaya.result = "Невалидный json, сорян! (ошибку см. в консоли)";
    }

    this.httpService.post("/profile/update-kaya", JSON.parse(this.kaya.params))
      .subscribe((r:Response):void => {
        this.kaya.result = r.json();
      });
  }


  onUpdateBlankClick() {
    this.reset();
    if (this.assertValidJsonGiven(JSON.stringify(JP.get(this.blankDocument, "/value")))) {
      this.blank.result = "Невалидный json, сорян! (ошибку см. в консоли)";
    }

    this.documentService.save(E_ENDPOINTS.API);
  }

  private assertValidJsonGiven(jsonString: any): any {
    if (this.isValidJson(jsonString)) {
      return false;
    }
    return true;
  }


  private isValidJson(str:string) {
    try {
      return JSON.parse(str);
    } catch (e) {
      console.error(e);
    }
    return null;
  }


  private reset() {
    this.profiles.result = "";
    this.blank.result = "";
    this.savedProfiles = [];
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/home/profile-utils-page.component.ts